import { Suspense, lazy, type ComponentPropsWithoutRef } from "react";

const PerTokenPricingCalculatorInner = lazy(() => import("./inner"));

export default function PerTokenPricingCalculator({
  officialModel,
}: ComponentPropsWithoutRef<typeof PerTokenPricingCalculatorInner>) {
  if (officialModel.billing_unit !== "1m-tokens") {
    return null;
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <PerTokenPricingCalculatorInner officialModel={officialModel} />
    </Suspense>
  );
}
